export enum LocaleCodes {
  ENGLISH = 'en-US',
  RUSSIAN = 'ru-RU',
  KYRGYZ = 'ky-KY',
}
